import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { SLIPPAGE_CONFIG } from "#/config/slippage";
const defaultValue = SLIPPAGE_CONFIG.options.highDelta.values[2]; // high delta's need more conservative prices

export const highDeltaSlippagePercentageAtom = atomWithStorage<number>(
  "highDeltaSlippage",
  defaultValue,
);

export const useHighDeltaSlippagePercentage = () => {
  const [highDeltaSlippagePercentage, setHighDeltaSlippagePercentage] = useAtom(
    highDeltaSlippagePercentageAtom,
  );

  const highDeltaSlippageFactor = Number(
    (highDeltaSlippagePercentage / 100).toFixed(3), // potentially 0.075
  );
  return {
    highDeltaSlippagePercentage,
    highDeltaSlippageFactor,
    setHighDeltaSlippagePercentage,
  };
};
